import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const brokenDisplayService = {
    getAllDisplays,
    getDisplay,
    updateDisplay,
    createDisplay,
    updateDisplayStatus 
};

const MODULE = {
    DISPLAY: 'broken-displays',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllDisplays(filter) {
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        is_locked: filter.isLocked,
        is_active: filter.isActive, 
      }
    }
    
    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
  
    return apiHelper(API_URL).get(`/${MODULE.DISPLAY}`, requestOptions)
  }

  export function getDisplay(id) {   
    return apiHelper(API_URL).get(`/${MODULE.DISPLAY}/${id}`)
  }

  export function updateDisplay(data) {
    
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).put(`/${MODULE.DISPLAY}/${data.id}`, requestOptions)
  }

  export function createDisplay(data) {
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).post(`/${MODULE.DISPLAY}`, requestOptions)
  }

  export function updateDisplayStatus(data) {
    const requestOptions = {
      is_active: data.isActive
    }
    
    return apiHelper(API_URL).patch(`/${MODULE.DISPLAY}/${data.id}`, requestOptions)
    
  }